import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import type { HTMLAttributes } from 'react';
import { EfficiencyFlagListFragmentFragmentDoc } from '@packages/gql/generated/shopping/EfficiencyFlagListFragmentFragmentDoc';
import type { PowerEfficiencyFlagProps } from './PowerEfficiencyFlag/PowerEfficiencyFlag';
import { PowerEfficiencyFlag } from './PowerEfficiencyFlag/PowerEfficiencyFlag';
import { TireEfficiencyFlag } from './TireEfficiencyFlag/TireEfficiencyFlag';

/* GraphQL */ `
  fragment EfficiencyFlagListFragment on Product {
    powerEfficiencyFlags {
      ...PowerEfficiencyFlagFragment
    }
    tireEfficiency {
      link
      flags {
        ...TireEfficiencyFlagFragment
      }
    }
  }
`;

export type EfficiencyFlagListProps = HTMLAttributes<HTMLDivElement> & {
  data: FragmentType<typeof EfficiencyFlagListFragmentFragmentDoc>;
  /**
   * Boolean to decide if layout should be rendered as row or column.
   * @default false
   * */
  horizontal?: boolean;
  /**
   * Size of the EfficiencyFlags.
   * @default "large"
   */
  size?: PowerEfficiencyFlagProps['size'];
};

export const EfficiencyFlagList = ({
  data,
  horizontal = false,
  size = 'large',
  className,
  ...props
}: EfficiencyFlagListProps) => {
  const { powerEfficiencyFlags, tireEfficiency } = getFragmentData(
    EfficiencyFlagListFragmentFragmentDoc,
    data,
  );

  return (
    <div
      className={`flex gap-1 text-left [&>button]:text-left ${horizontal ? 'flex-row' : 'flex-col'} ${className || ''}`}
      {...props}
    >
      {powerEfficiencyFlags?.map((powerEfficiencyFlagData, idx) => (
        <PowerEfficiencyFlag
          data={powerEfficiencyFlagData}
          // label next to the flag should only be shown if multiple flags are shown
          // skip label if horzontal is true
          showLabel={horizontal ? false : powerEfficiencyFlags.length > 1}
          size={size}
          // eslint-disable-next-line react/no-array-index-key
          key={idx}
        />
      ))}
      {tireEfficiency?.flags.map((tireEfficiencyFlagData) => (
        <TireEfficiencyFlag data={tireEfficiencyFlagData} link={tireEfficiency.link} />
      ))}
    </div>
  );
};
